import { create } from 'zustand';
import { supabase } from '../lib/supabase';
import type {
  ShadowRecruiter,
  ShadowRecruiterClaimResult,
  ShadowRecruiterInviteContext,
} from '../types/job';

type AdminShadowRecruiterRow = {
  item: ShadowRecruiter;
  total_count: number;
};

interface ShadowRecruiterState {
  shadowRecruiters: ShadowRecruiter[];
  loading: boolean;
  fetchShadowRecruiters: (search?: string) => Promise<void>;
  getInviteContext: (inviteToken: string) => Promise<ShadowRecruiterInviteContext | null>;
  claimInvite: (inviteToken: string) => Promise<ShadowRecruiterClaimResult>;
}

export const useShadowRecruiterStore = create<ShadowRecruiterState>(set => ({
  shadowRecruiters: [],
  loading: false,

  fetchShadowRecruiters: async (search?: string) => {
    set({ loading: true });

    try {
      const { data, error } = await supabase.rpc('admin_fetch_shadow_recruiters', {
        p_limit: 100,
        p_offset: 0,
        p_search: search?.trim() || null,
        p_claimed: false,
      });

      if (error) throw error;

      const rows = (data || []) as AdminShadowRecruiterRow[];
      set({
        shadowRecruiters: rows.map(row => row.item),
      });
    } finally {
      set({ loading: false });
    }
  },

  getInviteContext: async inviteToken => {
    const { data, error } = await supabase.rpc('get_shadow_recruiter_invite_context', {
      p_invite_token: inviteToken,
    });

    if (error) throw error;

    return (data as ShadowRecruiterInviteContext | null) ?? null;
  },

  claimInvite: async inviteToken => {
    const { data, error } = await supabase.rpc('claim_shadow_recruiter_invite', {
      p_invite_token: inviteToken,
    });

    if (error) throw error;

    return data as ShadowRecruiterClaimResult;
  },
}));
